module.exports = __webpack_public_path__ + "static/media/card_google-pay.6c5c3391.svg";